import RecordSearchFieldsHelpers from '#src/mixins/RecordSearchFieldsHelpers'
import { BooleanParser } from '@scholar/metadata-utils/boolean-parser'

export default {
  mixins: [RecordSearchFieldsHelpers],
  methods: {
    createNode (value) {
      let group
      if (['(', ')'].includes(value)) {
        group = 'ParenthesisNode'
      } else if (['and', 'or', 'not'].includes(value)) {
        group = 'OperationNode'
      } else {
        group = 'FieldNode'
      }
      return { value, group }
    },
    expressionStatus (query) {
      const valid = BooleanParser.test(query)
      if (query === '') {
        return 'default'
      } else if (valid) {
        return 'valid'
      } else {
        return 'invalid'
      }
    },
    getAvailableFieldIndices (fields) {
      return fields
        .map((field, idx) => ({ field, idx }))
        .filter(i => !this.isFieldEmpty(i.field))
        .map(i => i.idx)
    },
    getAvailableFields (fields) {
      return fields.filter(f => !this.isFieldEmpty(f))
    },
    getQueryFromSequence (sequence) {
      return sequence.map(f => f.value).join(' ')
    },
    sequenceFromIndices (sequence, indices) {
      return sequence.filter(f => f.group !== 'FieldNode' || indices.includes(f.value))
    },
    getDefaultSequence (fields, operator = 'and') {
      const seq = this.getAvailableFieldIndices(fields)
        .map(idx => [this.createNode(idx), this.createNode(operator)])
        .flat()

      seq.pop()
      return seq
    },
    buildSearch (fields, sequence) {
      const index = Object.fromEntries(this.getAvailableFieldIndices(fields)
        .map((val, idx) => [val, idx])
      )

      const newSequence = sequence
        .map(f => {
          if (f.group === 'FieldNode') {
            return { ...f, value: index[f.value] }
          }
          return f
        })

      return {
        query: this.getQueryFromSequence(newSequence),
        mapping: this.getAvailableFields(fields).map(f => ({
          [f.name]: f.value.value,
          option: f.value.option
        }))
      }
    }
  }
}
